<template>
  <section id="hero">
    <div
      class="container flex flex-col-reverse md:flex-row items-center px-6 mx-auto mt-10 space-y-0 md:space-y-o"
    >
      <div class="flex flex-col mb-24 space-y-8 md:w-1/2">
        <h2
          class="max-w-md text-8xl font-bold text-center mt-12 md:text-5xl md:text-left"
        >
          More than just shorter links
        </h2>
        <p class="max-w-sm text-center text-grey md:text-left">
          Build your brand's recognition and get detailed insights on how your
          links are performing
        </p>
        <div class="flex justify-center md:justify-start"> 
          <a
            href="#form"
            class=" p-3 text-xl leading-none border rounded-full bg-blue-500 text-white hover:bg-blue-300  mt-1 lg:mt-0"
            >Get Started
          </a>
        </div>
      </div>

      <div class="md:w-1/2">
        <img src="../assets/images/illustration-working.svg" alt="">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
};
</script>

<style scoped>
    h2{
        font-size: 60px;
         font-weight: 700;
    }
    p{
        font-size: 20px;
        color: gray;
    }
 </style>
